import {
  FETCH_LOAD_OWNER_REQUEST,
  FETCH_LOAD_OWNER_SUCCESS,
  FETCH_LOAD_OWNER_FALUIRE,
} from './loadAllOwnersTypes'

const initialState = {
  loading: false,
  allOwnerList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_OWNER_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_OWNER_SUCCESS : return {
      ...state,
      allOwnerList: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_OWNER_FALUIRE : return {
      ...state,
      loading: false,
      allOwnerList: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
